import React from 'react';
import PropTypes from 'prop-types';
import SovosRaisedButton from 's1-ui/sovos-raised-button/SovosRaisedButton';
import SovosButtonsGroup from 's1-ui/sovos-buttons-group/SovosButtonsGroup';
import SelectImportProfile from './comp/selectImportProfilePanel/SelectImportProfilePanelConnector';
import SelectImportPeriod from './comp/selectImportPeriod/SelectImportPeriod';
import ImportErrorDialog from "./comp/importErrorDialog/ImportErrorDialogConnector";
import DataFilePanel from 'shared/components/dataFilePanel/DataFilePanel';
import ImportInfoSection from './comp/importInfoSection/ImportInfoSection';
import { MONTHS } from 'shared/components/monthPicker/helpers/monthPickerConstants';
import './importDataPage.scss';

const initialState = {
  importDataDisabled: true,
  profileName: '',
  profileId: -1,
  fileName: '',
  acceptedFiles: [],
  rejectedFiles: [],
  selectedProfileRow: -1,
  uploadStep: 'upload',
  selectedPeriod: '',
  periodId: '',
  month: '',
  year: 0
};

class ImportDataPage extends React.Component {
  state = { ...initialState };

  componentWillMount() {
    document.title = 'Import data';
  }

  handleDropFiles = (acceptedFiles, rejectedFiles) => this.setState({ acceptedFiles, rejectedFiles, fileName: acceptedFiles.length === 1 ? acceptedFiles[0].name : '' });

  handleReset = () => this.setState({ ...initialState });

  handleImportData = () => this.setState({ uploadStep: 'progress' });

  handleFileUploadComplete = () => {
    console.log('File Upload Complete callback from page');
  };

  handleProfileSelect = ({ id, name }, selectedProfileRow) => this.setState({ profileId: id || -1, profileName: name || '', selectedProfileRow});

  handlePeriodChange = (year, month) => {
    const realMonthValue = month + 1;
    this.setState({
      year,
      month: MONTHS[month],
      selectedPeriod: `${year} - ${MONTHS[month]}`,
      periodId: `${year}${(realMonthValue.toString().length===1)?'0':''}${realMonthValue}`
    });
  };

  render () {
    const { acceptedFiles, rejectedFiles, uploadStep, profileId, periodId, profileName, fileName } = this.state;
    return (
      <div className="import-data__page">
        <h1>Import Data</h1>
        <hr />
        <SelectImportProfile onProfileSelect={ this.handleProfileSelect } selectedProfileRow={ this.state.selectedProfileRow } />
        <SelectImportPeriod onChange={ this.handlePeriodChange } month={ this.state.month } year={ this.state.year } />
        <div className="import-data__row_horizontal-content">
          <DataFilePanel
            title={ `3. Select Data File` }
            margin={ `0` }
            acceptedFiles={ acceptedFiles }
            rejectedFiles={ rejectedFiles }
            uploadStep={ uploadStep }
            url="/utm/v1/import"
            additionalInformation={ { profileId, periodId, appName: 'Sovos UTM' } }
            onDropFiles={ this.handleDropFiles }
            onFileUploadComplete={ this.handleFileUploadComplete }
          />
          <ImportInfoSection profileName={ profileName } fileName={ fileName } period={ this.state.selectedPeriod } style={ { margin: '55px 0 0 30px' } } />
        </div>
        <SovosButtonsGroup align="right" style={ { paddingRight: 15, margin: '15px 0 30px 0' } }>
          <SovosRaisedButton
            id="ResetImportDataButton"
            onClick={ this.handleReset }
            color="secondary"
            style={ { width: 90 } }
          >
            RESET
          </SovosRaisedButton>
          <SovosRaisedButton
            id="ImportDataButton"
            disabled={ profileId === -1 || !periodId || !fileName || uploadStep === 'progress' }
            onClick={ this.handleImportData }
            style={ { minWidth: 90 } }
          >
            IMPORT DATA
          </SovosRaisedButton>
        </SovosButtonsGroup>
        <ImportErrorDialog
          onDialogClose={ this.handleReset }
        />
      </div>
    );
  }
}

ImportDataPage.propTypes = {
  history: PropTypes.shape().isRequired
};

export default ImportDataPage;



// WEBPACK FOOTER //
// ./src/components/importData/ImportDataPage.js